import { ComponentDefinition } from '../../models';

export const wtDragButton: ComponentDefinition = {
    componentId: 'wtDragButton',
    template: require('./dragButton.component.html')
};
